module.exports = __webpack_public_path__ + "static/media/event_card_1.1fe1f7cb.png";